import React, { useState } from "react";
import { createCrosspoolMatches } from "services/matchService";
import * as Sentry from "@sentry/react";

const CreateCrosspoolMatchesButton = ({ tournament, location, onCreated }) => {
  const [goalsToWin, setGoalsToWin] = useState("1");
  const [showConfig, setShowConfig] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (!tournament || !tournament.teams || Object.keys(tournament.teams).length !== 2) {
      alert("Crosspool matches require exactly 2 pools.");
      return;
    }

    setIsLoading(true);
    try {
      await createCrosspoolMatches({ ...tournament, goalsToWin: parseInt(goalsToWin) || 1 });
      onCreated?.();
    } catch (error) {
      Sentry.captureException(error);
      console.error("Erreur lors de la création des matchs crosspool :", error);
      alert("❌ Une erreur est survenue lors de la création des matchs crosspool.");
    } finally {
      setIsLoading(false);
    }
  };

  const divisions = Object.keys(tournament?.teams || {});
  const canCreateCrosspool = divisions.length === 2 && !tournament?.makeDivisions && location?.allowCrossPool;

  if (!canCreateCrosspool) {
    return null;
  }

  if (showConfig) {
    return (
      <div className="bg-slate-800 p-4 rounded-lg border border-slate-700">
        <h4 className="text-slate-50 font-bold mb-3">Configuration des matchs inter-groupes</h4>
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <label className="text-slate-50 text-sm">Buts pour gagner:</label>
            <input
              type="number"
              min="1"
              max="10"
              inputMode="numeric"
              value={goalsToWin}
              onChange={(e) => setGoalsToWin(e.target.value)}
              onBlur={() => setGoalsToWin(String(Math.min(10, Math.max(1, parseInt(goalsToWin) || 1))))}
              className="bg-slate-800 text-slate-50 px-2 py-1 rounded border border-slate-700 w-16"
            />
            <span className="text-slate-300 text-xs">(1 = match simple 0-1)</span>
          </div>
          <div className="flex gap-2">
            <button
              onClick={handleClick}
              disabled={isLoading}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed font-bold"
            >
              {isLoading ? "Création en cours..." : "Créer les matchs inter-groupes"}
            </button>
            <button
              onClick={() => setShowConfig(false)}
              disabled={isLoading}
              className="px-4 py-2 bg-slate-700 text-slate-50 rounded hover:bg-slate-800/50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <button
      onClick={() => setShowConfig(true)}
      className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 font-bold"
    >
      Créer les matchs inter-groupes
    </button>
  );
};

export default CreateCrosspoolMatchesButton;